/* eslint-disable max-classes-per-file */
import { EventSourcePolyfill } from 'event-source-polyfill'
import { get } from './api'

export class Stream {
  constructor(getUrl, streamUrl, callback = () => {}) {
    this.callback = callback
    this.getUrl = getUrl
    this.closed = false

    this.timer = setInterval(() => {
      this.get()
    }, 3000)

    const eventSourceInitDict = {
      initialRetryDelayMillis: 1000,
      maxRetryDelayMillis: 30000,
      retryResetIntervalMillis: 60000,
      headers: {
        Accept: 'text/event-stream',
        'Cache-Control': 'no-cache',
      },
      skipDefaultHeaders: true,
    }

    this.source = new EventSourcePolyfill(streamUrl, eventSourceInitDict)
  }

  onError(callback) {
    this.source.onerror = error => {
      callback(error)
    }
    return this
  }

  onMessage(callback) {
    this.callback = callback
    this.source.addEventListener('message', event => {
      const json = JSON.parse(event.data)
      if (json && json.type) {
        callback(json)
      }
      this.handleEventHeartBeat()
    })
    return this
  }

  handleEventHeartBeat() {
    clearInterval(this.timer)
  }

  get() {
    get(this.getUrl).then(body => {
      if (!this.closed) {
        this.callback(body)
      }
    })
  }

  close() {
    this.source.close()
    this.closed = true
    clearInterval(this.timer)
  }
}

export class TokenStream extends Stream {
  constructor(url, id, applicantType) {
    super(
      `${url}/public/token/${id}${
        applicantType ? `?applicantType=${applicantType}` : ''
      }`,
      `${url}/public/stream/token/${id}${
        applicantType ? `?applicantType=${applicantType}` : ''
      }`,
    )
  }
}

export class StoreEventsStream extends Stream {
  constructor(url, id) {
    super('', `${url}/events/store_id/${id}?withHistory=true`)
  }
}
